"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Africa = _interopRequireDefault(require("../img/continentsIcons/Africa.png"));
var _Asia = _interopRequireDefault(require("../img/continentsIcons/Asia.png"));
var _Australia = _interopRequireDefault(require("../img/continentsIcons/Australia.png"));
var _Europe = _interopRequireDefault(require("../img/continentsIcons/Europe.png"));
var _LatinAmerica = _interopRequireDefault(require("../img/continentsIcons/LatinAmerica.png"));
var _USACanada = _interopRequireDefault(require("../img/continentsIcons/USA-Canada.png"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
// continents icons
var _default = exports.default = [{
  imgSrc: _Asia.default,
  label: 'אסיה',
  value: 'ASIA'
}, {
  disabled: true,
  disabledTooltip: 'באופן זמני לא ניתן',
  disabledTooltip_line_2: 'לרכישה',
  imgSrc: _USACanada.default,
  label: 'ארה"ב / קנדה',
  value: 'USA'
}, {
  imgSrc: _Africa.default,
  label: 'אפריקה',
  value: 'AFRICA'
}, {
  imgSrc: _Europe.default,
  label: 'אירופה',
  value: 'EUROPE'
}, {
  imgSrc: _LatinAmerica.default,
  label: 'אמריקה הלטינית',
  value: 'SOUTHAM'
}, {
  imgSrc: _Australia.default,
  label: 'אוסטרליה / ניו-זילנד',
  value: 'AUSTRALIA'
}];